import { useState } from "react";
import classNames from "classnames";
import BusinessCategories from "./BusinessCategories";
import BusinessToggle from "./BusinessToggle";

import './CategoriesSelector.scss';

export default function CategoriesSelector({ businesses, role, setEditedRole, disabled, onChange, setCategoryBusiness }) {
  const [selectedBusiness, setSelectedBusiness] = useState(() => businesses[0]?.id);

  return (
    <div className={classNames("__categories-selector", { '__categories-selector-disabled': disabled })}>
      <div className="business-list">
        <h3>Businesses</h3>
        { businesses.map(business => (
          <BusinessToggle disabled={disabled} key={business.id} business={business} role={role} selectedBusiness={selectedBusiness} setSelectedBusiness={setSelectedBusiness} />
        ))}
      </div>

      <div className="categories-list">
        <h3>Categories</h3>
        { selectedBusiness && <BusinessCategories disabled={disabled} businessId={selectedBusiness} role={role} setEditedRole={setEditedRole} onChange={onChange} setCategoryBusiness={setCategoryBusiness} /> }
      </div>
    </div>
  )
}
